// Shared helpers for the LinkedIn AI Skill Center screens.
export const unwrap = (res) => res?.data?.data ?? {};
export const errMsg = (e) => e?.response?.data?.error || e?.response?.data?.message || e.message || 'Something went wrong';
export const FIELD_BASE = 'w-full px-3 bg-[#F3F2F2] border border-[#E5E5E5] rounded text-[13px] outline-none focus:bg-white focus:border-[#0176D3] transition-all';
export const inputClass = `${FIELD_BASE} h-9`;
export const textareaClass = `${FIELD_BASE} min-h-[96px] py-2`;
export const btnPrimary = 'h-9 px-4 bg-[#0176D3] text-white rounded text-[13px] font-semibold hover:bg-[#014486] disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap';
export const btnGhost = 'h-9 px-3 bg-white border border-[#C9C9C9] rounded text-[13px] font-semibold text-[#0176D3] hover:bg-[#F3F2F2] disabled:opacity-50 whitespace-nowrap';

export const CATEGORY_LABELS = {
  content_creation: 'Content creation', engagement: 'Engagement', profile: 'Profile optimization',
  planning: 'Campaign planning', sales_outreach: 'Sales outreach', analytics: 'Analytics', crm_assist: 'CRM assistants',
};

export const CAPABILITY_BADGE = {
  available: ['sf-badge-success', 'Available'],
  pending_approval: ['sf-badge-warning', 'Waiting for LinkedIn approval'],
  unavailable: ['sf-badge-error', 'Unavailable'],
  manual_only: ['sf-badge-neutral', 'Manual workflow'],
  temporarily_unavailable: ['sf-badge-warning', 'Temporarily unavailable'],
};

// What "Save to Content Studio" stores for each skill. null = nothing to save as a single draft.
export function primaryText(skillId, o) {
  if (!o) return null;
  switch (skillId) {
    case 'linkedin.post.create': return o.draft;
    case 'linkedin.content.review': return o.revisedDraft;
    case 'linkedin.dm.draft': return o.messageDraft;
    case 'linkedin.comment.draft': return o.comments?.[0]?.text;
    case 'linkedin.carousel.create': return o.caption;
    case 'linkedin.content.repurpose': return o.assets?.[0]?.text;
    case 'crm.followup.draft': return o.body;
    case 'crm.proposal.draft': return o.body;
    case 'crm.campaign.content': return o.assets?.[0]?.text;
    default: return null;
  }
}

export const newKey = () => (crypto?.randomUUID ? crypto.randomUUID().replace(/-/g, '') : `k${Date.now()}${Math.random().toString(36).slice(2)}`);
